<template>
  <div class="app-container">
    <!-- 导入并使用NavBar组件 -->
    <NavBar />

    <!-- 根据当前路径控制tab容器的显示 -->
    <div v-if="showTabContainer" class="tab-container">
      <!-- 这里可以放置tab切换内容 -->
    </div>

    <!-- 页面内容区域 -->
    <router-view />

    <Footers></Footers>
  </div>
</template>

<script>
import { onMounted, onUnmounted, ref, watch, nextTick } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { useRoute } from 'vue-router'
import store from './store'
import NavBar from './components/NavBar.vue'
import Footers from './components/Footers.vue'

export default {
  name: 'App',
  components: {
    NavBar,
    Footers
  },
  setup() {
    const route = useRoute()
    const showTabContainer = ref(true)
    // 添加一个标志来跟踪对话框是否已经打开
    const isDialogVisible = ref(false)

    // 控制tab切换的显示与隐藏
    const showTabs = (show) => {
      showTabContainer.value = show
    }

    // 监听路由变化
    watch(() => route.path, (newPath) => {
      // 如果是首页则隐藏tab
      showTabContainer.value = newPath !== '/'
    })

    // 检测是否为移动设备
    const isMobile = () => {
      console.log('当前窗口宽度:', window.innerWidth)
      return window.innerWidth < 768;
    }

    // 显示移动设备提示
    const showMobileWarning = async () => {
      nextTick(() => {
        if (isMobile() && !isDialogVisible.value) {
          console.log('是移动设备')
          isDialogVisible.value = true;
          try {
            ElMessageBox.alert(
              '由于网页端格式不兼容移动端(手机、平板)使用，为了您有更好的体验，建议打开"二饼科技"微信小程序使用二饼',
              '设备提示',
              {
                confirmButtonText: '我知道了',
                type: 'warning',
                showClose: false,
                draggable: false
              }
            );
          } catch (error) {
            // 用户点击取消或关闭的处理
            console.log('用户关闭了提示框');
          } finally {
            // 无论成功还是失败，都重置对话框状态
            isDialogVisible.value = false;
          }
        }
      })
    }

    // 应用初始化
    const initializeApp = async () => {
      try {
        // 检查是否有保存的登录状态
        if (store.state.token) {
          // 可以在这里添加额外的初始化逻辑，如获取用户信息等
          console.log('应用初始化：用户已登录')
        } else {
          console.log('应用初始化：用户未登录')
        }

        // 默认检查当前路径，如果是首页则隐藏tab
        if (route.path === '/') {
          showTabContainer.value = false
        }

        // 初始化时检查是否为移动设备
        showMobileWarning();
      } catch (error) {
        console.error('应用初始化失败:', error)
        ElMessage.error('应用初始化失败')
      }
    }

    onMounted(() => {
      // 应用启动时检查登录状态
      initializeApp();
    })

    return {
      showTabContainer,
      showTabs
    }
  }
}
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  padding: 0;
  margin: 0;
  min-width: 800px;
}

html,
body,
div {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}

.app-container {
  width: 100vw;
  height: 100vh;
}

/* 主内容区域 */
.main-content {
  width: 100%;
  min-width: 800px;
  height: calc(100vh - 60px);
  overflow: hidden;
}

.main {
  height: 100%;
  height: calc(100vh - 60px);
}
</style>
